import { createBrowserHistory } from 'history'

const pathArray = window.location.pathname.split('/')

const history = createBrowserHistory({ basename: '/' + pathArray[1] })

export default history
